import "./App.css";
import "./responsive.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Logistics from "./pages/Logistics";
import Transport from "./pages/Transport";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Single from "./pages/Single";
import Favourites from "./pages/Favourites";
import LiveAuctions from "./pages/LiveAuctions";
import Tender from "./pages/Tender";
import Negotiation from "./pages/Negotiation";
import ConfirmBid from "./pages/ConfirmBid";
import Notification from "./pages/Notification";
import { useEffect, useState } from "react";
import { initUserSession } from "./services/auth.service";
import { useSelector } from "react-redux";
import { store } from "./redux/store";
import { setIsGlobalModalOpen, setModalData } from "./redux/modal";
import { useMediaQuery } from "react-responsive";
import Modal from "react-modal";
import { CONSTANTS } from "./shared/constants";
import {
  bid,
  getAdminDefaults,
  negotiate,
  offer,
} from "./services/btc-api.service";
import SearchedItems from "./pages/SearchedItems";
import { Shipping } from "./pages/Shipping";
import MyProfile from "./pages/MyProfile";
import PersonalInfoForm from "./components/PersonalInfoform";
import BusinessInfoForm from "./components/BusinessInfoform";
import Signup from "./pages/Signup";
import Verification from "./components/Verification";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import Purchase from "./pages/PurchaseRecorde";

function App() {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const modal = useSelector((state) => state.modal);
  const user = useSelector((state) => state.user.user);
  const modalData = useSelector((state) => state.modal.modalData);
  const imageBasePath =
    window.location.protocol + "//" + window.location.host + "/";
  let subtitle;
  const [value, setValue] = useState(0);
  const [taxValue, setTaxValue] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [adminDefaults, setAdminDefaults] = useState({
    serviceCenterOperationCharges: 0,
  });

  const handleIncrement = () => {
    setValue((prevValue) => prevValue + 1000);
  };

  const handleDecrement = () => {
    setValue((prevValue) => prevValue - 1000);
  };

  useEffect(() => {
    setTaxValue(CONSTANTS.GET_TAX_PRICE(value));
  }, [value]);

  useEffect(() => {
    setTotalValue(
      value + taxValue + adminDefaults.serviceCenterOperationCharges
    );
  }, [value, taxValue, adminDefaults.serviceCenterOperationCharges]);

  useEffect(() => {
    initUserSession();
    getAndSetAdminDefaults();
  }, []);

  const getAndSetAdminDefaults = async () => {
    try {
      const res = await getAdminDefaults();

      setAdminDefaults({
        ...res,
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (modalData && modalData.currentPrice) {
      setValue(modalData.currentPrice);
    }
  }, [modalData]);

  function afterOpenModal() {
    if (subtitle) subtitle.style.color = "#f00";
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      height: "90vh",
      overflowY: "scroll",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "90vw",
      padding: "0 2%",
      boxShadow:
        "0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05), 0 100px 80px rgba(0, 0, 0, 0.07)",
      borderRadius: 12,
      backgroundColor: "rgb(221 219 219)",
    },
  };

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logistics" element={<Logistics />} />
        <Route path="/transport" element={<Transport />} />
        <Route path="/personalinfoform" element={<PersonalInfoForm />} />
        <Route path="/businessinfoform" element={<BusinessInfoForm />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/purchaseRecorde" element={<Purchase />} />

        {/* <Route path="/register" element={<Register />} /> */}
        <Route path="/car-details/:id" element={<Single />} />
        <Route path="/favourites" element={<Favourites />} />
        <Route path="/search" element={<SearchedItems />}>
          <Route
            path="/search/:maker/:country/:text"
            element={<SearchedItems />}
          />
        </Route>
        <Route path="/live-auction" element={<LiveAuctions />} />
        <Route path="/tender" element={<Tender />} />
        <Route path="/negotiation" element={<Negotiation />} />
        <Route path="/confirm-bid" element={<ConfirmBid />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
      <Footer />
      <ToastContainer />
      <Modal
        isOpen={modal.isOpen}
        onAfterOpen={afterOpenModal}
        ariaHideApp={false}
        onRequestClose={() => {
          store.dispatch(setIsGlobalModalOpen(false));
          store.dispatch(setModalData(null));
          setValue(0);
        }}
        style={customStyles}
        contentLabel="Bidding details"
      >
        <>
          <div className="confirm-details">
            <h1>Details of Bidding Conditions</h1>
            <div className="confirm-tables">
              <div className="table1">
                <div className="left">
                  <h3>Trade Term</h3>
                  <h3>Delivery address</h3>
                  <h3>
                    Delivery address <br /> for documents
                  </h3>
                  <h3>
                    Estimated <br /> Arrival Date
                  </h3>
                </div>
              </div>
              <div className="table1">
                <div className="left">
                  <h3>Bid Price</h3>
                  <h3>Inland Delivery</h3>
                  {adminDefaults.serviceCenterOperationCharges && (
                    <h3>
                      Service Center <br />
                      Operation Charge
                    </h3>
                  )}
                  <h3 className="last">Total Price</h3>
                </div>
                <div className="right">
                  <h3> {value.toLocaleString()} Yen</h3>
                  <h3>{taxValue.toLocaleString()} Yen</h3>

                  {adminDefaults.serviceCenterOperationCharges && (
                    <h3>
                      {adminDefaults.serviceCenterOperationCharges.toLocaleString()}
                      &nbsp; Yen
                    </h3>
                  )}
                  <h3 className="last">{totalValue.toLocaleString()} Yen</h3>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "5%",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <p className="understanding">
              We ask for your understanding as there are cases where the ocean
              freight is modified by the shipping companies without any
              notification.
              <br />
              container shipping fee is a reference price based on one 40 foot
              HC container.
              <br />
              It's assumed that other vehicles will be loaded into the same
              container.
              <br />
              The actual expense will depend on the amount of vehicles and
              container size.
              <br />
            </p>
            <Counter
              value={value}
              handleDecrement={handleDecrement}
              handleIncrement={handleIncrement}
              setValue={setValue}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <div style={{ flex: 1, padding: isMobile ? "4%" : "auto" }}>
              <button className="terms-btn">Change Trade Term</button>
            </div>
            <button
              onClick={async () => {
                const body = {
                  auctionType: modalData.auctionType,
                  userId: user._id,
                  bidPrice: value,
                  totalPrice: totalValue,
                  serviceCharges: adminDefaults.serviceCenterOperationCharges,
                  taxValue: taxValue,
                };

                if (modalData.auctionType === CONSTANTS.AUCTION_TYPES.LIVE) {
                  const res = await bid(modalData.vehicleId, body);

                  if (res !== undefined) {
                    store.dispatch(setIsGlobalModalOpen(false));
                    // window.location.reload();
                  }
                } else if (
                  modalData.auctionType === CONSTANTS.AUCTION_TYPES.TENDER
                ) {
                  const res = await offer(modalData.vehicleId, body);

                  if (res !== undefined) {
                    store.dispatch(setIsGlobalModalOpen(false));
                    // window.location.reload();
                  }
                } else if (
                  modalData.auctionType === CONSTANTS.AUCTION_TYPES.NEGOTIATION
                ) {
                  const res = await negotiate(modalData.vehicleId, body);

                  if (res !== undefined) {
                    store.dispatch(setIsGlobalModalOpen(false));
                    // window.location.reload();
                  }
                }
              }}
              className="bid-btn confirm"
              style={{
                height: 60,
                width: isMobile ? "90%" : 230,
                marginTop: 15,
                marginBottom: 20,
                marginRight: 58,
              }}
            >
              <img src={imageBasePath + "hammer.png"} alt={imageBasePath} />
              Confirm{" "}
              {modalData &&
                modalData.auctionType === CONSTANTS.AUCTION_TYPES.LIVE
                ? "Bid"
                : "Offer"}
            </button>
          </div>
        </>
      </Modal>
    </div>
  );
}

const Counter = ({ value, handleDecrement, handleIncrement, setValue }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <div
      className="counter"
      style={{
        alignItems: "start",
        transform: isMobile ? "translateY(0px)" : "translateY(13px)",
      }}
    >
      <div className="input-box">
        <input
          type="number"
          className="hide-arrows"
          value={value}
          onChange={(e) => setValue(parseInt(e.target.value))}
        />
        Yen
      </div>
      <div className="count-btns">
        <button onClick={handleIncrement}>
          <i className="fa fa-angle-up"></i>
        </button>
        <button onClick={handleDecrement}>
          <i className="fa fa-angle-down"></i>
        </button>
      </div>
    </div>
  );
};

export default App;
